import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { QUICK_ACTION_PARAM } from "./searchRegistry";

// Opens a page's form when it was opened from a search quick action
// (`?action=<key>`, e.g. add-loan). `handlers` maps the keys this page
// supports to the same function its own button runs (leave a key out, or
// set it to null, when the user can't do it here), so the page's own
// permission checks still apply. Waits until `ready` (data and settings
// loaded). The param is removed either way, so a refresh doesn't reopen it.
export const useQuickActionFromUrl = (handlers, ready) => {
  const location = useLocation();
  const history = useHistory();
  const wanted = new URLSearchParams(location.search).get(QUICK_ACTION_PARAM);
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    if (!wanted || !ready) return;
    const params = new URLSearchParams(location.search);
    params.delete(QUICK_ACTION_PARAM);
    const rest = params.toString();
    history.replace({ pathname: location.pathname, search: rest ? `?${rest}` : "", hash: location.hash });
    const run = handlersRef.current?.[wanted];
    if (typeof run === "function") run();
  }, [wanted, ready, history, location.pathname, location.search, location.hash]);
};
